import axios from '../axios'

/*
 * 陪玩师申请列表
 */

export const selectByPage = (data) => {
    return axios({
        url: '/technologyApply/selectByPage',
        method: 'post',
        data
    })
}



export const batchApprove = (data) => {
    return axios({
        url: '/technologyApply/batchApprove',
        method: 'post',
        data
    })
}

export const batchReject = (data) => {
    return axios({
        url: '/technologyApply/batchReject',
        method: 'post',
        data
    })
}

export const batchPull = (data) => {
    return axios({
        url: '/technologyApply/batchPull',
        method: 'post',
        data
    })
}

export const batchPullTransferReject = (data) => {
    return axios({
        url: '/technologyApply/batchPullTransferReject',
        method: 'post',
        data
    })
}




// WEBPACK FOOTER //
// ./src/http/play/playapply.js